import { App } from "vue";
import baseBootstrap from "../../base/ts/baseBootstrap";
import QuickSearch from "./pertwo.quicksearch";
import loadComponents from "./loadComponents";
import Cookies from "js-cookie";
import DayJs from "../../base/ts/composables/DayJs";

const app: App<Element> = baseBootstrap();
loadComponents(app);

function checkNoMinimumOrderValueHash() {
    let hash = window.location.hash;
    let json;

    if (hash.length > 1) {
        try {
            hash = atob(hash.substring(1));
            json = JSON.parse(hash);
        } catch (e) {
            return false;
        }

        if (json.no_minimum_order_value_until !== null && json.no_minimum_order_value_until !== undefined) {
            let date = json.no_minimum_order_value_until;
            Cookies.set(btoa("no_minimum_order_value_until"), date, {
                expires: DayJs.getInstance()(date, "YYYY-MM-DD HH:mm:ss").toDate(),
            });
        }

        if (
            json.no_minimum_order_value_for_pickup_until !== null &&
            json.no_minimum_order_value_for_pickup_until !== undefined
        ) {
            let date = json.no_minimum_order_value_for_pickup_until;
            Cookies.set(btoa("no_minimum_order_value_for_pickup_until"), date, {
                expires: DayJs.getInstance()(date, "YYYY-MM-DD HH:mm:ss").toDate(),
            });
        }
    }
}
checkNoMinimumOrderValueHash();

// This is added to support the Elementor Accordion widget
function toggleAccordionItem(item, open) {
    if (open) {
        item.classList.add("active");

        // Add elementor-active class to support elementor stling in Elementor Accordion widget
        item.querySelector(".elementor-tab-title").classList.add("elementor-active");
        item.querySelector(".elementor-tab-content").classList.add("elementor-active");
    } else {
        item.classList.remove("active");

        // Remove elementor-active class for accordion item content.
        item.querySelector(".elementor-tab-title").classList.remove("elementor-active");
        item.querySelector(".elementor-tab-content").classList.remove("elementor-active");
    }
}

window.addEventListener("load", () => {
    // Temp fix show elementor components/widgets with animations
    document.querySelectorAll("[data-settings]").forEach((el) => {
        let elementSettings = JSON.parse(el.getAttribute("data-settings"));
        if (elementSettings.hasOwnProperty("_animation")) {
            el.classList.remove("elementor-invisible");
        }
    });

    // This is added to support the Elementor Accordion widget toggle function
    document.querySelectorAll(".elementor-accordion").forEach((accordionElement) => {
        const accordionItems = accordionElement.querySelectorAll(".elementor-accordion-item");

        // Initially activate the first accordion item
        if (accordionItems.length > 0) {
            toggleAccordionItem(accordionItems[0], true);
        }

        accordionItems.forEach((accordionItem) => {
            accordionItem.querySelector(".elementor-tab-title").addEventListener("click", (e) => {
                if (!accordionItem.classList.contains("active")) {
                    // Close all accordion items
                    accordionItems.forEach((item) => {
                        toggleAccordionItem(item, false);
                    });

                    toggleAccordionItem(accordionItem, true);
                } else {
                    // Close if the currently open accordion item is clicked.
                    toggleAccordionItem(accordionItem, false);
                }
            });
        });
    });
});

// Register serviceWorker
if ("serviceWorker" in navigator) {
    navigator.serviceWorker
        .register("/service-worker.js")
        .then(function (registration) {
            registration.addEventListener("updatefound", function () {
                // If updatefound is fired, it means that there's
                // a new service worker being installed.
                // You can listen for changes to the installing service worker's
                // state via installingWorker.onstatechange
            });
        })
        .catch(function (error) {
            console.log("Service worker registration failed:", error);
        });
} else {
    // Service workers are not supported by browser
}

document.addEventListener("DOMContentLoaded", function () {
    new QuickSearch();
});
